import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { TabMetaDataResolver } from './shared/inteceptors/tab-metadata-resolver';
import { defaultTabs, TabKeyEnum, SubTypeEnum } from "ngx-exdr-stmx-common";


export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./layout/pages-layout/pages-layout.component').then(c => c.PagesLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('./layout/home/home.component').then(c => c.HomeComponent)
            },
            {
                path: defaultTabs[TabKeyEnum.Chat], // For following enums Chat & Language, both have same endpoint
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Profile],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Requests],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent)
            },
            {
                path: defaultTabs[TabKeyEnum.EspRecords],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },            
            // {
            //     path: defaultTabs[TabKeyEnum.Feed],
            //     loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            // },
            // {
            //     path: defaultTabs[TabKeyEnum.Library],
            //     loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            // },
            {
                path: defaultTabs[TabKeyEnum.Members],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.ContactCard],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.ScoreCard],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.ssnotes],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Calendar],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Boards],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Dashboards],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Activities],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Blogs],
                loadChildren: () => import('ngx-exdr-stmx-idenedi/blogs').then(m => m.BlogsModule),
                data: {
                  tabKey: TabKeyEnum.Blogs
                }
            },
            {                
                matcher: (url: UrlSegment[]) => {
                    return customTabUrlMatcher(SubTypeEnum.BLOG, url[0]);
                },
                loadChildren: () => import('ngx-exdr-stmx-idenedi/blogs').then(m => m.BlogsModule)
            },
            {
                path: defaultTabs[TabKeyEnum.Vacancies],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Intajy],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.EngagementPro],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.SocialMedia],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.EspAttendance],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Sellexe],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.ForYou],
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },
            {
                path: defaultTabs[TabKeyEnum.Library],                
                data: {
                  tabKey: TabKeyEnum.Library
                },                        
                loadChildren: () => import('ngx-exdr-stmx-technadopt').then(m => m.ProductsModule)
            },
            {                
                matcher: (url: UrlSegment[]) => {
                    return customTabUrlMatcher(SubTypeEnum.TOPIC, url[0]);
                },
                loadChildren: () => import('ngx-exdr-stmx-technadopt').then(m => m.ProductDetailsModule)
            },
            {
                path: defaultTabs[TabKeyEnum.Feed],
                data: {
                  tabKey: TabKeyEnum.Feed
                },                
                loadChildren: () => import('ngx-exdr-stmx-idenedi/news').then(m => m.NewsModule)
            },
            {                
                matcher: (url: UrlSegment[]) => {
                    return customTabUrlMatcher(SubTypeEnum.FEEDS, url[0]);
                },
                loadChildren: () => import('ngx-exdr-stmx-idenedi/news').then(m => m.NewsModule)
            },
            {
                matcher: (url: UrlSegment[]) => {
                  return customTabUrlMatcher(SubTypeEnum.IFRAME, url[0]);
                },
                data: {
                  pageWidth: 'full',
                },
                loadComponent: () =>
                  import("./layout/iframe/iframe.component").then(
                    c => c.IframeComponent
                  )
            },            
            {
                path: '**',
                //redirectTo: ''
                loadComponent: () => import('./coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
            },                    
            
        ]        
        .map((r: any) => {
            let obj: any = { metaData: TabMetaDataResolver };                  
            if (!r.resolve) {
              r.resolve = obj;
            } else {
              r.resolve['metaData'] = TabMetaDataResolver;
            }
            return r;
          })
    },
    //add route that will be used to navigate to if route not found
];

function customTabUrlMatcher(tabCastType: SubTypeEnum, url: UrlSegment) {
    let postFix = '';
    switch (tabCastType) {
        case SubTypeEnum.IFRAME:
            postFix = '-i';
            break;
        case SubTypeEnum.FEEDS:
          postFix = '-f';
          break;
        case SubTypeEnum.BLOG:
          postFix = '-b';
          break;
        case SubTypeEnum.TOPIC:
            postFix = '-lb';
            break;
        // case TabCastTypeEnum.DASHBOARD:
        //   postFix = '-db';
        //   break;
        default:
            break;
    }
    if (postFix == '') {
        return null;
    }
    if(url){
    url.path = url.path.split('?')[0]
        if (url.path.endsWith(postFix)) {
            const path = url.path.split(`-`);
            const slug = path.slice(0, path?.length - 1).join('-');
            return {
                consumed: [url], posParams: {
                    slug: new UrlSegment(slug, {}),
                    postFix: new UrlSegment(postFix, {})
                }
            }
        }
    }
    return null;
}
